/* Bundle Builder V2 - Auto Design (custom). Free tiers 3-7 (uniform or per-poster size) + wall layouts + frames.
   Wall layouts can use a real room photo with empty frames (block settings "mockup" + "positions"):
   the selected posters are cropped out of the product images and dropped into the frames. */
(function () {
  'use strict';

  /* Where the poster sits inside a product image (square canvas, poster + baked shadow), in % of the image.
     Slightly inset so it fits both catalog templates; the few mm lost are hidden by the frame anyway. */
  var POSTER_CROP = { left: 18.4, top: 4.9, right: 80.3, bottom: 92.8 };

  function initAll() {
    document.querySelectorAll('[data-bundle-builder-v2]').forEach(init);
  }

  /* "20 x 30 cm", "20 x 30cm", "20cm x 30cm" -> "20x30" */
  function norm(value) {
    return String(value || '').toLowerCase().split('cm').join('').split(' ').join('').split(' ').join('');
  }

  function area(sizeKey) {
    var d = String(sizeKey).split('x');
    return (parseInt(d[0], 10) || 0) * (parseInt(d[1], 10) || 0);
  }

  /* "x, y, w, h[, ox, oy, ow, oh]" per line -> [{x,y,w,h,o}]
     x..h = white insert inside the frame; optional ox..oh = outer edge of the frame (used with "No frame"). */
  function parsePositions(text) {
    var out = [];
    String(text || '').split(/\r?\n/).forEach(function (line) {
      var n = line.split(/[,;\s]+/).filter(Boolean).map(parseFloat);
      if (n.length >= 4 && n.slice(0, 4).every(function (v) { return !isNaN(v); })) {
        var p = { x: n[0], y: n[1], w: n[2], h: n[3], o: null };
        if (n.length >= 8 && n.slice(4, 8).every(function (v) { return !isNaN(v); })) {
          p.o = { x: n[4], y: n[5], w: n[6], h: n[7] };
        }
        out.push(p);
      }
    });
    return out;
  }

  function init(root) {
    if (root.__bbInit) return;
    root.__bbInit = true;

    var moneyFormat = root.getAttribute('data-money-format') || '€{{amount}}';
    function readJSON(attr, fb) {
      try { var v = JSON.parse(root.getAttribute(attr)); return v == null ? fb : v; } catch (e) { return fb; }
    }
    var tiers = readJSON('data-tiers', [{ qty: 3, pct: 0, code: '' }]);
    var strings = readJSON('data-strings', {});
    var layoutsRaw = readJSON('data-layouts', []);
    var framesData = readJSON('data-frames', []);

    /* Composition: columns separated by "|", sizes top-to-bottom within a column.
       "30x40,30x40 | 50x70" -> columns [["30x40","30x40"],["50x70"]]. "size:count" also expands. */
    var layouts = layoutsRaw.map(function (l) {
      var columns = [];
      String(l.slots || '').split('|').forEach(function (colStr) {
        var col = [];
        colStr.split(',').forEach(function (part) {
          var bits = part.split(':');
          var size = norm(bits[0]);
          var count = parseInt(bits[1], 10) || 1;
          if (!size) return;
          for (var i = 0; i < count; i++) col.push(size);
        });
        if (col.length) columns.push(col);
      });
      return {
        name: l.name, pct: parseFloat(l.pe) || l.pct || 0, code: l.code || '', columns: columns,
        codeF: l.cf || '', pctF: parseFloat(l.pf) || 0,
        /* Fixed amount off (cents) — exact bundle prices; matches "amount off" discount codes */
        amt: Math.round((parseFloat(l.ao) || 0) * 100), amtF: Math.round((parseFloat(l.aof) || 0) * 100),
        img: l.img || null, alt: l.alt || '', ar: l.ar || null, pos: parsePositions(l.pos)
      };
    }).filter(function (l) { return l.columns.length > 0; });

    var framesByMat = {};
    framesData.forEach(function (f) {
      var m = String(f.m || '').toLowerCase();
      if (!framesByMat[m]) framesByMat[m] = {};
      framesByMat[m][f.s] = f;
    });

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bb-card]'));
    var bar = root.querySelector('[data-bb-bar]');
    var collapseBtn = root.querySelector('[data-bb-collapse]');
    function setCollapsed(c) {
      if (!bar || !collapseBtn) return;
      bar.classList.toggle('is-collapsed', c);
      collapseBtn.setAttribute('aria-expanded', c ? 'false' : 'true');
      collapseBtn.setAttribute('aria-label', collapseBtn.getAttribute(c ? 'data-label-more' : 'data-label-less') || '');
    }
    if (collapseBtn) {
      try { if (window.localStorage.getItem('bbBarCollapsed') === '1') setCollapsed(true); } catch (e) {}
      collapseBtn.addEventListener('click', function () {
        var c = !bar.classList.contains('is-collapsed');
        setCollapsed(c);
        try { window.localStorage.setItem('bbBarCollapsed', c ? '1' : '0'); } catch (e) {}
      });
    }
    var wall = root.querySelector('[data-bb-wall]');
    var lightbox = root.querySelector('[data-bb-lightbox]');
    var lightboxImg = root.querySelector('[data-bb-lightbox-img]');
    var groups = {
      tier: root.querySelector('[data-bb-tier-group]'),
      size: root.querySelector('[data-bb-size-group]'),
      layout: root.querySelector('[data-bb-layout-group]'),
      globalSizes: root.querySelector('[data-bb-global-sizes]')
    };
    var els = {
      count: root.querySelector('[data-bb-count]'),
      hint: root.querySelector('[data-bb-hint]'),
      framesNote: root.querySelector('[data-bb-frames-note]'),
      totalRegular: root.querySelector('[data-bb-total-regular]'),
      total: root.querySelector('[data-bb-total]'),
      saving: root.querySelector('[data-bb-saving]'),
      fab: root.querySelector('[data-bb-fab]'),
      fabTotal: root.querySelector('[data-bb-fab-total]')
    };

    cards.forEach(function (card) {
      var dataEl = card.querySelector('[data-bb-data]');
      try { card.__data = JSON.parse(dataEl.textContent); } catch (e) { card.__data = { id: 0, sp: 0, img: null, variants: [] }; }
    });

    var state = {
      mode: (root.hasAttribute('data-layouts-only') || (root.querySelector('input[name="bb-mode"]:checked') || {}).value === 'layout') ? 'layout' : 'free',
      sizeMode: 'uniform',
      tier: tiers[0],
      size: (root.querySelector('input[name="bb-size"]:checked') || {}).value || null,
      layoutIdx: 0,
      frame: ''
    };
    var selected = new Map();
    var slots = [];
    var fillOrder = [];

    function activeLayout() { return layouts[state.layoutIdx] || null; }
    function maxCount() { return state.mode === 'free' ? state.tier.qty : slots.length; }
    function countSelected() {
      if (state.mode === 'free') return selected.size;
      var n = 0;
      slots.forEach(function (s) { if (s.card) n++; });
      return n;
    }
    /* With frames, a layout can use its own code / % (block settings code_frame + pct_frame) */
    function layoutAmount(l, framed) { return framed ? (l.codeF ? l.amtF : 0) : l.amt; }
    function layoutPct(l, framed) {
      var a = layoutAmount(l, framed);
      if (a > 0) { var r = layoutRegular(l, framed); if (r > 0) return a * 100 / r; }
      return (framed && l.codeF) ? l.pctF : l.pct;
    }
    /* Regular price of a full layout, from the most common poster price per size (+ frames) */
    function layoutRegular(l, framed) {
      var mat = framesByMat[state.frame] || {};
      var regular = 0;
      l.columns.forEach(function (col) {
        col.forEach(function (s) {
          if (typicalPrice[s] == null) return NaN;
          regular += typicalPrice[s] || 0;
          if (framed && mat[s]) regular += mat[s].p;
        });
      });
      return regular;
    }
    function layoutCode(l, framed) { return (framed && l.codeF) ? l.codeF : l.code; }
    function activePct() { return state.mode === 'free' ? state.tier.pct : (activeLayout() ? layoutPct(activeLayout(), !!state.frame) : 0); }
    function activeCode() { return state.mode === 'free' ? state.tier.code : (activeLayout() ? layoutCode(activeLayout(), !!state.frame) : ''); }
    function eachSelected(cb) {
      if (state.mode === 'free') selected.forEach(function (card) { cb(card); });
      else slots.forEach(function (s) { if (s.card) cb(s.card); });
    }
    function sizeLabel(key) {
      var d = String(key).split('x');
      return d.length === 2 ? d[0] + ' x ' + d[1] + ' cm' : key;
    }

    function tmpl(str, vars) {
      str = str || '';
      Object.keys(vars).forEach(function (k) { str = str.split('{' + k + '}').join(vars[k]); });
      return str;
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var comma = amount.replace('.', ',');
      var noDec = String(Math.round(cents / 100));
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/g, amount)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, comma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec);
    }

    function selectedOptions(card) {
      var opts = {};
      var inputs = card.querySelectorAll('input[data-bb-opt]:checked');
      Array.prototype.forEach.call(inputs, function (input) {
        opts[input.getAttribute('data-position')] = input.value;
      });
      return opts;
    }

    function resolveVariant(card, sizeKey) {
      var data = card.__data;
      var opts = selectedOptions(card);
      var list = data.variants.filter(function (v) {
        if (sizeKey && data.sp > 0 && norm(v.opts[data.sp - 1]) !== sizeKey) return false;
        for (var pos in opts) {
          if (v.opts[pos - 1] !== opts[pos]) return false;
        }
        return true;
      });
      var available = list.filter(function (v) { return v.a; });
      return available[0] || list[0] || null;
    }

    /* Size the card should resolve against in free mode */
    function freeSize(card) {
      if (state.sizeMode === 'per') {
        var r = card.querySelector('input[data-bb-psize]:checked');
        if (r) return r.value;
      }
      return state.size;
    }

    /* Actual size of the resolved variant (for frames aggregation) */
    function variantSize(card) {
      var d = card.__data;
      if (d.sp > 0 && card.__variant) return norm(card.__variant.opts[d.sp - 1]);
      return null;
    }

    function cardImage(card) {
      return (card.__variant && card.__variant.img) || card.__data.img;
    }

    function cardTitle(card) {
      var t = card.querySelector('.bundle-card__title');
      return t ? t.textContent.trim() : '';
    }

    function uncheckCard(card) {
      var check = card.querySelector('[data-bb-check]');
      check.checked = false;
      card.classList.remove('is-selected');
    }

    function unassign(card) {
      if (card.__slotIdx == null) return;
      slots[card.__slotIdx].card = null;
      delete card.__slotIdx;
      uncheckCard(card);
    }

    /* Fill empty slots largest-size first */
    function assign(card) {
      for (var k = 0; k < fillOrder.length; k++) {
        var i = fillOrder[k];
        if (slots[i].card) continue;
        var v = resolveVariant(card, slots[i].size);
        if (v && v.a) {
          slots[i].card = card;
          card.__slotIdx = i;
          card.__variant = v;
          return true;
        }
      }
      return false;
    }

    function resetSelections() {
      selected = new Map();
      slots = [];
      var lay = activeLayout();
      if (lay) {
        lay.columns.forEach(function (col, ci) {
          col.forEach(function (s) { slots.push({ size: s, col: ci, card: null }); });
        });
      }
      fillOrder = slots.map(function (s, i) { return i; }).sort(function (a, b) {
        return area(slots[b].size) - area(slots[a].size) || a - b;
      });
      cards.forEach(function (card) { delete card.__slotIdx; uncheckCard(card); });
    }

    function refreshCard(card) {
      var check = card.querySelector('[data-bb-check]');
      var priceEl = card.querySelector('[data-bb-price]');
      var un = card.querySelector('[data-bb-unavailable]');
      var img = card.querySelector('[data-bb-image]');
      var v = null, usable = false;

      if (state.mode === 'free') {
        v = resolveVariant(card, freeSize(card));
        usable = !!(v && v.a);
        if (!usable && check.checked) {
          selected.delete(card.__data.id);
          uncheckCard(card);
        }
      } else {
        if (card.__slotIdx != null) {
          v = resolveVariant(card, slots[card.__slotIdx].size);
          usable = !!(v && v.a);
          if (!usable) unassign(card);
        }
        if (card.__slotIdx == null) {
          var seen = {};
          for (var k = 0; k < fillOrder.length; k++) {
            var i = fillOrder[k];
            if (slots[i].card) continue;
            var s = slots[i].size;
            if (seen[s]) continue;
            seen[s] = 1;
            var cv = resolveVariant(card, s);
            if (cv && cv.a) { v = cv; usable = true; break; }
          }
          if (!v) v = resolveVariant(card, null);
        }
      }

      card.__variant = v;
      card.classList.toggle('is-bb-unavailable', !usable);
      if (un) un.hidden = usable;
      check.disabled = !usable;
      if (priceEl && v) priceEl.textContent = formatMoney(v.p);
      if (img) {
        var src = cardImage(card);
        if (src && img.getAttribute('src') !== src) {
          img.removeAttribute('srcset');
          img.setAttribute('src', src);
        }
      }
    }

    function enforceLimit() {
      var full = countSelected() >= maxCount();
      cards.forEach(function (card) {
        var check = card.querySelector('[data-bb-check]');
        card.classList.toggle('is-bb-locked', full && !check.checked && !check.disabled);
      });
    }

    function trimFree() {
      var keys = Array.from(selected.keys());
      while (selected.size > state.tier.qty) {
        var lastId = keys.pop();
        var card = selected.get(lastId);
        if (card) uncheckCard(card);
        selected.delete(lastId);
      }
    }

    function frameLines() {
      if (!state.frame) return [];
      var counts = {};
      eachSelected(function (card) {
        var s = variantSize(card);
        if (s) counts[s] = (counts[s] || 0) + 1;
      });
      var mat = framesByMat[state.frame] || {};
      var lines = [];
      Object.keys(counts).forEach(function (s) {
        var f = mat[s];
        if (f && f.a) lines.push({ id: f.id, qty: counts[s], p: f.p });
      });
      return lines;
    }

    function nextSlotIndex() {
      for (var k = 0; k < fillOrder.length; k++) {
        if (!slots[fillOrder[k]].card) return fillOrder[k];
      }
      return -1;
    }

    /* ------- Wall: real room photo with empty frames ------- */
    function posterCropStyle(img) {
      var w = POSTER_CROP.right - POSTER_CROP.left;
      var h = POSTER_CROP.bottom - POSTER_CROP.top;
      img.style.width = (10000 / w).toFixed(3) + '%';
      img.style.height = (10000 / h).toFixed(3) + '%';
      img.style.left = (-POSTER_CROP.left * 100 / w).toFixed(3) + '%';
      img.style.top = (-POSTER_CROP.top * 100 / h).toFixed(3) + '%';
    }

    function renderMockup(lay, target) {
      var wall = target;
      var stage = wall.__mockStage;
      if (!stage || wall.__mockFor !== lay) {
        wall.innerHTML = '';
        stage = document.createElement('div');
        stage.className = 'bb-mock';
        if (lay.ar) stage.style.aspectRatio = String(lay.ar);
        var bg = document.createElement('img');
        bg.className = 'bb-mock__bg';
        bg.src = lay.img;
        bg.alt = lay.alt || '';
        bg.decoding = 'async';
        stage.appendChild(bg);
        stage.__slots = slots.map(function (slot, i) {
          var el = document.createElement('button');
          el.type = 'button';
          el.className = 'bb-mslot';
          el.setAttribute('data-bb-slot', i);
          stage.appendChild(el);
          return el;
        });
        wall.appendChild(stage);
        wall.__mockStage = stage;
        wall.__mockFor = lay;
      }
      var next = nextSlotIndex();
      /* No frame: the print covers the whole frame of the photo (outer edge), like a poster stuck on the wall */
      var noFrame = !state.frame;
      stage.classList.toggle('is-noframe', noFrame);
      slots.forEach(function (slot, i) {
        var el = stage.__slots[i];
        var p = lay.pos[i];
        var r = (noFrame && p.o) ? p.o : p;
        el.style.left = r.x + '%';
        el.style.top = r.y + '%';
        el.style.width = r.w + '%';
        el.style.height = r.h + '%';
        var src = slot.card ? (cardImage(slot.card) || '') : '';
        var key = (slot.card ? 'f:' + src : 'e' + (i === next ? 'n' : '')) + (noFrame ? '|nf' : '|f');
        el.classList.toggle('is-next', !slot.card && i === next);
        if (el.__key === key) return;
        el.__key = key;
        el.innerHTML = '';
        el.classList.toggle('is-filled', !!slot.card);
        if (slot.card) {
          var crop = document.createElement('span');
          crop.className = 'bb-mslot__poster';
          var img = document.createElement('img');
          img.src = src;
          img.alt = '';
          posterCropStyle(img);
          crop.appendChild(img);
          var x = document.createElement('span');
          x.className = 'bb-mslot__remove';
          x.setAttribute('aria-hidden', 'true');
          x.textContent = '×';
          el.appendChild(crop);
          el.appendChild(x);
          el.setAttribute('aria-label', cardTitle(slot.card) + ' — ' + sizeLabel(slot.size) + ' (remove)');
        } else {
          var plus = document.createElement('span');
          plus.className = 'bb-mslot__plus';
          plus.setAttribute('aria-hidden', 'true');
          plus.textContent = '+';
          var lbl = document.createElement('span');
          lbl.className = 'bb-mslot__size';
          lbl.textContent = sizeLabel(slot.size);
          el.appendChild(plus);
          el.appendChild(lbl);
          el.setAttribute('aria-label', sizeLabel(slot.size) + ' — empty');
        }
      });
    }

    /* ------- Wall: simple schematic fallback (no photo configured) ------- */
    function renderSchematic() {
      wall.__mockStage = null;
      wall.__mockFor = null;
      wall.innerHTML = '';
      var cols = [];
      slots.forEach(function (slot, i) {
        if (!cols[slot.col]) {
          cols[slot.col] = document.createElement('div');
          cols[slot.col].className = 'bb-col';
        }
        var el = document.createElement('button');
        el.type = 'button';
        el.className = 'bb-slot' + (slot.card ? ' is-filled' : '');
        el.setAttribute('data-bb-slot', i);
        var d = slot.size.split('x');
        el.style.width = Math.round((parseInt(d[0], 10) || 30) * 1.6) + 'px';
        el.style.height = Math.round((parseInt(d[1], 10) || 40) * 1.6) + 'px';
        if (slot.card) {
          var img = document.createElement('img');
          img.src = cardImage(slot.card) || '';
          img.alt = '';
          el.appendChild(img);
        } else {
          var span = document.createElement('span');
          span.textContent = sizeLabel(slot.size);
          el.appendChild(span);
        }
        cols[slot.col].appendChild(el);
      });
      cols.forEach(function (c) { if (c) wall.appendChild(c); });
    }

    function renderWall() {
      if (!wall) return;
      wall.hidden = state.mode !== 'layout';
      if (wall.hidden) return;
      var lay = activeLayout();
      var useMock = !!(lay && lay.img && lay.pos.length === slots.length);
      wall.classList.toggle('is-mockup', useMock);
      if (useMock) renderMockup(lay, wall);
      else renderSchematic();
      if (sheet && !sheet.hidden && useMock) renderMockup(lay, sheetWall);
    }

    /* ------- Bundle tray: mini wall in the sticky bar, always in view ------- */
    var sheet = root.querySelector('[data-bb-sheet]');
    var sheetWall = root.querySelector('[data-bb-sheet-wall]');
    var tray = root.querySelector('[data-bb-tray]');
    var peekBtn = root.querySelector('[data-bb-peek]');

    function hasMockup() {
      var lay = activeLayout();
      return state.mode === 'layout' && !!(lay && lay.img && lay.pos.length === slots.length);
    }

    function trayItem(card, size, isNext, removeAttr) {
      var el = document.createElement(card ? 'button' : 'span');
      el.className = 'bb-tray__item' + (card ? ' is-filled' : '') + (isNext ? ' is-next' : '');
      if (size) {
        var d = String(size).split('x');
        el.style.setProperty('--bb-w', Math.max(18, Math.round((parseInt(d[0], 10) || 30) * 0.66)) + 'px');
      }
      if (card) {
        el.type = 'button';
        el.setAttribute(removeAttr[0], removeAttr[1]);
        el.setAttribute('aria-label', cardTitle(card) + ' (remove)');
        el.title = cardTitle(card);
        var img = document.createElement('img');
        img.src = cardImage(card) || '';
        img.alt = '';
        posterCropStyle(img);
        el.appendChild(img);
      }
      return el;
    }

    function renderTray() {
      if (!tray) return;
      tray.innerHTML = '';
      if (state.mode === 'layout') {
        var next = nextSlotIndex();
        /* same left-to-right order as the wall */
        var lay = activeLayout();
        var order = slots.map(function (s, i) { return i; });
        if (lay && lay.pos.length === slots.length) {
          order.sort(function (a, b) { return (lay.pos[a].x - lay.pos[b].x) || (lay.pos[a].y - lay.pos[b].y); });
        }
        var cols = [], lastX = null;
        order.forEach(function (i) {
          var x = lay && lay.pos[i] ? Math.round(lay.pos[i].x) : i;
          if (lastX === null || Math.abs(x - lastX) > 2) { cols.push([]); lastX = x; }
          cols[cols.length - 1].push(i);
        });
        cols.forEach(function (col) {
          var c = document.createElement('span');
          c.className = 'bb-tray__col';
          col.forEach(function (i) {
            c.appendChild(trayItem(slots[i].card, slots[i].size, i === next, ['data-bb-tray-slot', i]));
          });
          tray.appendChild(c);
        });
      } else {
        var picked = Array.from(selected.values());
        for (var k = 0; k < state.tier.qty; k++) {
          var card = picked[k];
          tray.appendChild(trayItem(card || null, null, !card && k === picked.length, card ? ['data-bb-tray-card', card.__data.id] : null));
        }
      }
      if (peekBtn) peekBtn.hidden = !hasMockup();
    }

    function openSheet() {
      if (!sheet || !hasMockup()) return;
      sheet.hidden = false;
      renderMockup(activeLayout(), sheetWall);
      document.documentElement.style.overflow = 'hidden';
      (window.requestAnimationFrame || setTimeout)(function () { sheet.classList.add('is-open'); });
    }

    function closeSheet() {
      if (!sheet || sheet.hidden) return;
      sheet.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { sheet.hidden = true; }, 220);
    }

    function refuse() {
      bar.classList.remove('bb-flash');
      void bar.offsetWidth;
      bar.classList.add('bb-flash');
    }

    var lastCount = -1;
    function updateBar() {
      var n = countSelected();
      var max = maxCount();
      var pct = activePct();
      bar.style.setProperty('--bb-progress', max ? Math.min(n / max, 1) : 0);
      if (lastCount !== -1 && n !== lastCount) {
        els.count.classList.remove('bb-bump');
        void els.count.offsetWidth;
        els.count.classList.add('bb-bump');
      }
      lastCount = n;
      renderTray();
      els.count.textContent = tmpl(strings.selected || '{count}/{max}', { count: n, max: max });
      var remaining = max - n;
      if (remaining > 0) {
        if (state.mode === 'layout') {
          var ni = nextSlotIndex();
          var next = ni >= 0 ? sizeLabel(slots[ni].size) : '';
          els.hint.textContent = tmpl(strings.slot || '', { n: remaining, size: next, pct: Math.round(pct) });
        } else {
          els.hint.textContent = tmpl(strings.pick || '', { n: remaining, pct: Math.round(pct) });
        }
      } else {
        els.hint.textContent = tmpl(strings.complete || '', { pct: Math.round(pct) });
      }
      var postersTotal = 0;
      eachSelected(function (card) { if (card.__variant) postersTotal += card.__variant.p; });
      var lines = frameLines();
      var framesTotal = 0, framesQty = 0;
      lines.forEach(function (l) { framesTotal += l.p * l.qty; framesQty += l.qty; });
      var total = postersTotal + framesTotal;
      var discounted = Math.round(total * (100 - pct) / 100);
      var lay = activeLayout();
      if (state.mode === 'layout' && lay && n === max && layoutAmount(lay, !!state.frame) > 0) {
        discounted = Math.max(0, total - layoutAmount(lay, !!state.frame));
      }
      els.totalRegular.textContent = (n > 0 && pct > 0) ? formatMoney(total) : '';
      els.total.textContent = n > 0 ? formatMoney(discounted) : '';
      els.saving.textContent = (n > 0 && pct > 0) ? tmpl(strings.save || '', { amount: formatMoney(total - discounted) }) : '';
      if (els.framesNote) {
        els.framesNote.textContent = (n > 0 && framesQty > 0) ? tmpl(strings.frames || '', { n: framesQty, amount: formatMoney(framesTotal) }) : '';
      }
      var complete = n > 0 && n === max;
      bar.classList.toggle('is-complete', complete);
      if (els.fab) {
        els.fab.hidden = !complete;
        if (els.fabTotal) els.fabTotal.textContent = complete ? formatMoney(discounted) : '';
      }
    }

    function refreshAll() {
      cards.forEach(refreshCard);
      enforceLimit();
      renderWall();
      updateBar();
    }

    function syncModeUI() {
      var free = state.mode === 'free';
      if (groups.tier) groups.tier.hidden = !free;
      if (groups.size) groups.size.hidden = !free;
      if (groups.layout) groups.layout.hidden = free;
      if (groups.globalSizes) groups.globalSizes.hidden = state.sizeMode === 'per';
      root.classList.toggle('is-bb-persize', free && state.sizeMode === 'per');
    }

    function goToCheckout() {
      var n = countSelected();
      if (n === 0 || n !== maxCount()) return;
      var parts = [];
      eachSelected(function (card) { if (card.__variant) parts.push(card.__variant.id + ':1'); });
      frameLines().forEach(function (l) { parts.push(l.id + ':' + l.qty); });
      var url = '/cart/' + parts.join(',');
      var code = activeCode();
      if (code) url += '?discount=' + encodeURIComponent(code);
      window.location.assign(url);
    }

    /* ------- Lightbox (zoom) ------- */
    function openLightbox(card) {
      if (!lightbox || !lightboxImg) return;
      var src = cardImage(card);
      if (!src) return;
      lightboxImg.setAttribute('src', src.replace(/width=\d+/, 'width=1600'));
      lightbox.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.hidden = true;
      lightboxImg.removeAttribute('src');
      document.documentElement.style.overflow = '';
    }

    root.addEventListener('click', function (e) {
      var zoomBtn = e.target.closest('[data-bb-zoom]');
      if (zoomBtn) {
        e.preventDefault();
        e.stopPropagation();
        openLightbox(zoomBtn.closest('[data-bb-card]'));
        return;
      }
      if (e.target.closest('[data-bb-peek]')) { openSheet(); return; }
      if (e.target.closest('[data-bb-sheet-close]') || e.target === sheet) { closeSheet(); return; }
      var trayEl = e.target.closest('[data-bb-tray-slot], [data-bb-tray-card]');
      if (trayEl) {
        if (trayEl.hasAttribute('data-bb-tray-slot')) {
          var ti = parseInt(trayEl.getAttribute('data-bb-tray-slot'), 10);
          if (slots[ti] && slots[ti].card) unassign(slots[ti].card);
        } else {
          var cid = parseInt(trayEl.getAttribute('data-bb-tray-card'), 10);
          var c2 = selected.get(cid);
          if (c2) { selected.delete(cid); uncheckCard(c2); }
        }
        refreshAll();
        return;
      }
      var slotEl = e.target.closest('[data-bb-slot]');
      if (slotEl) {
        var idx = parseInt(slotEl.getAttribute('data-bb-slot'), 10);
        if (slots[idx] && slots[idx].card) {
          unassign(slots[idx].card);
          refreshAll();
        } else {
          /* Empty frame: scroll to the posters grid */
          closeSheet();
          var grid = root.querySelector('.bundle-builder__grid');
          if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        return;
      }
      if (e.target.closest('[data-bb-lightbox-close]') || e.target === lightbox) {
        closeLightbox();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox && !lightbox.hidden) closeLightbox();
      if (e.key === 'Escape') closeSheet();
    });

    /* ------- State changes ------- */
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'bb-mode') {
        state.mode = t.value;
        resetSelections();
        syncModeUI();
        refreshAll();
      } else if (t.name === 'bb-sizemode') {
        state.sizeMode = t.value;
        if (state.sizeMode === 'per') {
          cards.forEach(function (card) {
            var r = card.querySelector('input[data-bb-psize][value="' + state.size + '"]');
            if (r) r.checked = true;
          });
        }
        syncModeUI();
        refreshAll();
      } else if (t.name === 'bb-tier') {
        state.tier = tiers.filter(function (x) { return String(x.qty) === t.value; })[0] || tiers[0];
        trimFree();
        refreshAll();
      } else if (t.name === 'bb-size') {
        state.size = t.value;
        refreshAll();
      } else if (t.name === 'bb-layout') {
        state.layoutIdx = parseInt(t.value, 10) || 0;
        resetSelections();
        refreshAll();
        if (wall) {
          wall.classList.remove('is-swapping');
          void wall.offsetWidth;
          wall.classList.add('is-swapping');
        }
      } else if (t.name === 'bb-frame') {
        state.frame = t.value;
        renderLayoutPrices();
        renderWall();
        updateBar();
      } else if (t.hasAttribute('data-bb-psize') || t.hasAttribute('data-bb-opt')) {
        refreshAll();
      } else if (t.hasAttribute('data-bb-check')) {
        var card = t.closest('[data-bb-card]');
        if (t.checked) {
          if (countSelected() >= maxCount()) {
            t.checked = false;
            refuse();
            return;
          }
          if (state.mode === 'free') {
            selected.set(card.__data.id, card);
            card.classList.add('is-selected');
          } else {
            if (!assign(card)) {
              t.checked = false;
              refuse();
              return;
            }
            card.classList.add('is-selected');
          }
        } else {
          if (state.mode === 'free') selected.delete(card.__data.id);
          else unassign(card);
          card.classList.remove('is-selected');
        }
        refreshAll();
      }
    });

    if (els.fab) els.fab.addEventListener('click', goToCheckout);

    /* ------- Layout cards: bundle price vs. regular price ------- */
    var typicalPrice = (function () {
      var counts = {};
      cards.forEach(function (card) {
        var d = card.__data;
        if (!d.sp) return;
        d.variants.forEach(function (v) {
          var s = norm(v.opts[d.sp - 1]);
          counts[s] = counts[s] || {};
          counts[s][v.p] = (counts[s][v.p] || 0) + 1;
        });
      });
      var out = {};
      Object.keys(counts).forEach(function (s) {
        var best = null, n = -1;
        Object.keys(counts[s]).forEach(function (p) { if (counts[s][p] > n) { n = counts[s][p]; best = parseInt(p, 10); } });
        out[s] = best;
      });
      return out;
    })();

    function renderLayoutPrices() {
      var framed = !!state.frame;
      var mat = framesByMat[state.frame] || {};
      layouts.forEach(function (l, li) {
        var regular = 0, ok = true;
        l.columns.forEach(function (col) {
          col.forEach(function (s) {
            if (typicalPrice[s] == null) ok = false;
            regular += typicalPrice[s] || 0;
            if (framed) { if (mat[s]) regular += mat[s].p; else ok = false; }
          });
        });
        var pct = layoutPct(l, framed);
        var amt = layoutAmount(l, framed);
        var price = amt > 0 ? Math.max(0, regular - amt) : Math.round(regular * (100 - pct) / 100);
        var el = root.querySelector('[data-bb-lprice="' + li + '"]');
        if (el) {
          el.innerHTML = ok && regular ? '<strong>' + formatMoney(price) + '</strong>' +
            (pct > 0 ? ' <s>' + formatMoney(regular) + '</s>' : '') : '';
        }
        var badge = root.querySelector('[data-bb-lbadge="' + li + '"]');
        if (badge) badge.textContent = '−' + Math.round(pct) + '%';
      });
    }
    renderLayoutPrices();

    /* ?layout=2 in the URL preselects the 2nd layout (used by the homepage teaser) */
    try {
      var qi = parseInt(new URLSearchParams(window.location.search).get('layout'), 10);
      if (qi >= 1 && qi <= layouts.length && state.mode === 'layout') {
        var lr = root.querySelector('input[name="bb-layout"][value="' + (qi - 1) + '"]');
        if (lr) { lr.checked = true; state.layoutIdx = qi - 1; resetSelections(); }
      }
    } catch (e) {}

    /* Light reveal-on-scroll for the poster cards and step titles */
    if ('IntersectionObserver' in window && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      Array.prototype.forEach.call(root.querySelectorAll('.bundle-card, .bb-step-title, .bb-layout-card'), function (el, i) {
        el.classList.add('bb-reveal');
        el.style.setProperty('--bb-i', i % 4);
        io.observe(el);
      });
    }

    /* Preload the room photos so switching layouts is instant */
    layouts.forEach(function (l) { if (l.img) { var i = new Image(); i.src = l.img; } });

    resetSelections();
    syncModeUI();
    refreshAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
